import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExceptionHelper } from './../../../../helper';

import { CustomerSummaryService } from './customer-summary.service';

import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4';

@Component({
  selector: 'app-customer-summary',
  templateUrl: './customer-summary.component.html'
})
export class CustomerSummaryComponent implements OnInit, AfterViewInit {

  applied: Boolean = true;
  activateCheckboxStatus: number;

  customers: any[];
  dataTable: any;

  constructor(
    private exception: ExceptionHelper,
    private translateService: TranslateService,
    private customerSummaryService: CustomerSummaryService,
    private chRef: ChangeDetectorRef) {
    translateService.setDefaultLang('en-us');
  }

  ngAfterViewInit() {
    this.getSummary();
  }

  ngOnInit() {

  }


  apply() {
    this.getSummary();
  }

  checkboxStatus(input) {
    this.applied = input.isApply;
    this.activateCheckboxStatus = input.activateCheckboxStatus;
  }

  getSummary() {
    this.customerSummaryService.getSummary(this.activateCheckboxStatus).subscribe( (data: any) => {
      this.applied = true;

      if ($.fn.dataTable.isDataTable('#customersDataTables')) { $('#customersDataTables').DataTable().destroy(); }

          this.customers = data.customerListModel;
          this.chRef.detectChanges();

          const table: any = $('#customersDataTables');
          this.dataTable = table.DataTable();
        },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
        });




  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-summary/customer-summary.component.ts